// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/dashboard/services/dashboardService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { DashboardLayoutData, DashboardLayoutResolvido } from '../types';

const BASE = '/api/dashboard';

export const dashboardService = {
  async getLayout(): Promise<DashboardLayoutResolvido> {
    const { data } = await apiClient.get<DashboardLayoutResolvido>(`${BASE}/layout`);
    return data;
  },

  async salvarMeuLayout(layout: DashboardLayoutData): Promise<void> {
    await apiClient.put(`${BASE}/layout/meu`, layout);
  },

  async restaurarPadrao(): Promise<void> {
    await apiClient.delete(`${BASE}/layout/meu`);
  },

  // ── Layout padrão POR PERFIL (Fase 3 — administração) ─────────────────

  async getLayoutPerfil(perfilId: number): Promise<DashboardLayoutResolvido> {
    const { data } = await apiClient.get<DashboardLayoutResolvido>(`${BASE}/layout/perfil/${perfilId}`);
    return data;
  },

  async salvarLayoutPerfil(perfilId: number, layout: DashboardLayoutData): Promise<void> {
    await apiClient.put(`${BASE}/layout/perfil/${perfilId}`, layout);
  },

  async removerLayoutPerfil(perfilId: number): Promise<void> {
    await apiClient.delete(`${BASE}/layout/perfil/${perfilId}`);
  },

  // ── Layout padrão da EMPRESA (Fase 4 — administração) ─────────────────

  async getLayoutEmpresa(): Promise<DashboardLayoutResolvido> {
    const { data } = await apiClient.get<DashboardLayoutResolvido>(`${BASE}/layout/empresa`);
    return data;
  },

  async salvarLayoutEmpresa(layout: DashboardLayoutData): Promise<void> {
    await apiClient.put(`${BASE}/layout/empresa`, layout);
  },

  async removerLayoutEmpresa(): Promise<void> {
    await apiClient.delete(`${BASE}/layout/empresa`);
  },
};
